import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

export const TextareaStyle = styled.div`
  height: auto;
  width: 100%;

  .textarea-element {
    ${fontFamily.sourceSansPro.regular}
    background-color: ${colors.veryPaleBlue};
    border: solid 1px ${colors.grayishBlue};
    border-radius: 8px;
    color: ${colors.veryDarkGrayishBlue};
    display: block;
    font-size: 14px;
    height: auto;
    line-height: 20px;
    padding: 8px 16px;
    width: 100%;

    &.default-theme {
      background-color: ${colors.veryPaleBlue};
      border: solid 1px ${colors.grayishBlue};
    }
  }
`;
